export default "__VITE_ASSET__BNkXQtjZ__"